module.exports = __webpack_public_path__ + "img/stan_invest_logo.ab6e12be.svg";